import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-grey py-4"
}
const _hoisted_3 = { class: "d-flex align-center mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-warning"
}
const _hoisted_5 = {
  key: 1,
  class: "text-caption text-grey-darken-1"
}
const _hoisted_6 = { class: "tp-transfer__value" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_9 = { class: "tp-transfer__value" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_12 = { class: "text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "900px",
    persistent: "",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("上位計画から転記", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    })
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.candidates.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 転記できる項目がありません。帳票設定の転記ルールを確認してください。 "))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_checkbox, {
                              "model-value": _ctx.isAllSelected,
                              indeterminate: _ctx.isPartiallySelected,
                              label: "選べる項目をすべて選択",
                              density: "compact",
                              "hide-details": "",
                              color: "primary",
                              "onUpdate:modelValue": _ctx.toggleAll
                            }, null, 8, ["model-value", "indeterminate", "onUpdate:modelValue"]),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.overwrite,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.overwrite) = $event)),
                              label: "入力済みの項目も上書きする",
                              density: "compact",
                              "hide-details": "",
                              color: "warning"
                            }, null, 8, ["modelValue"])
                          ]),
                          (_ctx.overwrite && _ctx.overwriteCount > 0)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "warning",
                                variant: "tonal",
                                density: "compact",
                                class: "mb-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 入力済みの" + _toDisplayString(_ctx.overwriteCount) + "項目が上位計画の内容で置き換わります。 ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_table, { density: "compact" }, {
                            default: _withCtx(() => [
                              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { style: {"width":"48px"} }),
                                  _createElementVNode("th", { style: {"width":"20%"} }, "項目"),
                                  _createElementVNode("th", { style: {"width":"32%"} }, "現在の内容"),
                                  _createElementVNode("th", { style: {"width":"32%"} }, "転記される内容"),
                                  _createElementVNode("th", { style: {"width":"16%"} }, "参照元")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (candidate) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: candidate.itemKey
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_checkbox, {
                                        "model-value": _ctx.selectedItemKeys.includes(candidate.itemKey),
                                        disabled: !_ctx.isSelectable(candidate),
                                        density: "compact",
                                        "hide-details": "",
                                        color: "primary",
                                        "onUpdate:modelValue": ($event: any) => (_ctx.toggle(candidate.itemKey))
                                      }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", null, _toDisplayString(candidate.itemName), 1),
                                      (candidate.resolution !== 'resolved')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.resolutionLabel(candidate)), 1))
                                        : (_ctx.needsOverwrite(candidate))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 入力済みのため「上書きする」が必要です "))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_6, [
                                      (candidate.currentValue)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(candidate.currentValue), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_8, "（未入力）"))
                                    ]),
                                    _createElementVNode("td", _hoisted_9, [
                                      (candidate.candidateValue)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(candidate.candidateValue), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "（転記元が未入力）"))
                                    ]),
                                    _createElementVNode("td", _hoisted_12, _toDisplayString(candidate.sourcePlanLabel || "—"), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ], 64))
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                disabled: _ctx.transferring,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" キャンセル ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                loading: _ctx.transferring,
                disabled: _ctx.selectedItemKeys.length === 0,
                onClick: _ctx.execute
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 転記する（" + _toDisplayString(_ctx.selectedItemKeys.length) + "件） ", 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}